import { Koi } from '@ksyos/koi';
import { concat, slice } from 'lodash';
import type { Section } from '@common/formEngine/formEngine.types';
import type { DeepPickPath } from '@common/utils/deepPickUtils';
import type { NullablePrimitives } from '@common/utils/utilityTypes';
import type { ExternalReferralContentKeys } from '@common/validation/customControls/externalReferral';
import type { HearingLossAudiologistConsultDataBase } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsultDataBase';
import { dependsOn } from '@common/formEngine/dependsOn';
import { hearingLossAudiologistConsultSectionsBase } from '@common/validation/customControls/hearingLoss/hearingLossAudiologistConsultDataBase';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';

export type HearingLossAudiologistConsultData = HearingLossAudiologistConsultDataBase &
    NullablePrimitives<{
        binnen_welke_termijn: string;
        datum_afspraak: string | Date;
        evaluatie_consult: boolean;
        overige_opmerkingen_vervolg: string;
    }>;

export type HearingLossAudiologistConsultKey = DeepPickPath<HearingLossAudiologistConsultData>;

const vervolgSection: Section<HearingLossAudiologistConsultData, ExternalReferralContentKeys> = {
    fields: [
        {
            isRequired: true,
            key: 'evaluatie_consult',
            label: 'Evaluatie consult',
            type: 'boolean',
        },
        {
            draftSchema: Koi.when('evaluatie_consult', {
                is: true,
                otherwise: null,
                then: getTextInputStringSchema(true),
            }),
            finalSchema: Koi.when('evaluatie_consult', {
                is: true,
                otherwise: null,
                then: getTextInputStringSchema(true),
            }),
            include: dependsOn('evaluatie_consult'),
            key: 'binnen_welke_termijn',
            label: 'Binnen welke termijn',
            type: 'textInput',
        },
        {
            draftSchema: Koi.when('evaluatie_consult', {
                is: true,
                otherwise: null,
                then: Koi.koi().date().allow(null),
            }),
            finalSchema: Koi.when('evaluatie_consult', {
                is: true,
                otherwise: null,
                then: Koi.koi().date(),
            }),
            include: dependsOn('evaluatie_consult'),
            isRequired: true,
            key: 'datum_afspraak',
            label: 'Datum afspraak',
            type: 'dateInput',
        },
        {
            key: 'overige_opmerkingen_vervolg',
            label: 'Overige opmerkingen',
            type: 'textArea',
        },
    ],
    title: 'Vervolg',
};

export const hearingLossAudiologistConsultSections: Section<
    HearingLossAudiologistConsultData,
    ExternalReferralContentKeys
>[] = insertItem(
    hearingLossAudiologistConsultSectionsBase,
    hearingLossAudiologistConsultSectionsBase.length - 2,
    vervolgSection
);

function insertItem<T>(array: T[], index: number, item: T) {
    return concat(slice(array, 0, index), item, slice(array, index));
}
